module.exports = __webpack_public_path__ + "img/fitness4.39df0569.png";